import { Ml_Log_Status, PlainMlLogDto } from "@generated/graphql";
import { IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { getQuestionsGenLogsStatus } from "helpers/index";
import QuestionsGeneratingLogStatus from "components/QuestionsGeneratingLogStatus";
import dayjs from "dayjs";
import { RefetchFunction } from "@apollo/client/react/hooks/useSuspenseQuery";
import AccordionCard from "./AccordionCard";

export type QuestionsGenLog = Pick<PlainMlLogDto, "createdAt" | "id" | "status"> & { skillTitle: string };

interface QuestionsGeneratingLogsProps {
  logs: QuestionsGenLog[] | undefined;
  refetchLogs: RefetchFunction<unknown, Record<string, never>>;
  afterRefetchLogs?: RefetchFunction<unknown, Record<string, never>>;
}

const QuestionsGeneratingLogs = ({ logs, refetchLogs, afterRefetchLogs }: QuestionsGeneratingLogsProps) => {
  const [refetchTimeout, setRefetchTimeout] = useState<NodeJS.Timeout | null>(null);
  const hide = !logs?.length;
  const logsStatus = getQuestionsGenLogsStatus(logs);

  useEffect(() => {
    if (logsStatus === Ml_Log_Status.Initialized && !refetchTimeout) {
      const timeout = setTimeout(
        () =>
          refetchLogs()
            .then(() => {
              if (afterRefetchLogs) afterRefetchLogs();
            })
            .finally(() => {
              setRefetchTimeout(null);
            }),
        30000
      );

      setRefetchTimeout(timeout);
    }
  }, [logs, refetchTimeout]);

  return (
    <AccordionCard
      title='Генерация вопросов'
      hide={hide}
      TextFieldEnd={
        logsStatus && (
          <IconButton
            sx={{
              width: 36,
              height: 36,
            }}>
            <QuestionsGeneratingLogStatus status={logsStatus} />
          </IconButton>
        )
      }>
      <Table
        size='small'
        sx={{ "& .MuiTableCell-root": { paddingLeft: 0 } }}>
        <TableHead>
          <TableRow sx={{ "& th": { border: "none", "&:last-of-type": { paddingRight: 0 } } }}>
            <TableCell>Навык</TableCell>
            <TableCell>Статус</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {logs?.map((log) => (
            <TableRow
              key={log.id}
              sx={{
                "&:last-child td": { border: 0 },
                "& td": { borderLeft: "none", borderRight: "none", "&:last-of-type": { paddingRight: 0 } },
              }}>
              <Tooltip title={dayjs(log.createdAt).format("DD.MM.YYYY HH:mm:ss")}>
                <TableCell>{log.skillTitle}</TableCell>
              </Tooltip>
              <TableCell>
                <QuestionsGeneratingLogStatus status={log.status} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </AccordionCard>
  );
};

export default QuestionsGeneratingLogs;
